<template>
  <div id="Confirmation">
    <ApopBar/>
    <b-container id="confirmationForm">
      <p>Enter the unique code you received below. Codes are valid for 24 hours.
        If you did not receive a code, a new one can be requested from your profile.
        If you still do not receive a code, please contact the administrators.</p>
      <b-row>
        <b-col class="text-center">
          <b-alert variant="warning" :show="inError" style="display:inline-block;">
            {{ confirmErrorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <b-form @submit="submitCode">
        <b-form-group v-if="!confirmType" label="Select the communication to be verified">
          <b-form-radio-group>
            <b-form-radio v-model="form.confirmType" name="some-radios" value="email">Email</b-form-radio>
            <b-form-radio v-model="form.confirmType" name="some-radios" value="phone_number">Phone #</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group id="codeGroup" label="Verification Code:" label-for="codeInput">
          <b-form-input id="codeInput" type="text" required v-model="form.verifyCode"></b-form-input>
        </b-form-group>
        <b-button class="mr-2" type="submit" variant="outline-danger">Submit</b-button>
      </b-form>
    </b-container>

    <b-modal id="successModal"
             ref="successModal"
             hide-header
             ok-only
             body-bg-variant="dark"
             body-class="default-color"
             ok-variant="outline-danger"
             footer-bg-variant="dark"
             @ok="doRedirect"
             @show="timedRedirect"
    >
      <p>Thank you for confirming your information. You will be redirected in 5 seconds.</p>
    </b-modal>
  </div>

</template>

<script>
  import ApopBar from '../components/ApopBar'
  import { Auth } from 'aws-amplify'

  export default {
    name: 'confirmation',
    props: { confirmType: String },
    components: {
      ApopBar
    },
    data () {
      return {
        inError: false,
        confirmErrorMessage: '',
        form: {
          verifyCode: '',
          confirmType: ''
        }
      }
    },
    methods: {
      submitCode (e) {
        e.preventDefault()
        let attr
        (this.confirmType) ? attr = this.confirmType : attr = this.form.confirmType
        Auth.verifyCurrentUserAttributeSubmit(attr, this.form.verifyCode).then(() => {
            Auth.currentAuthenticatedUser({ bypassCache: true }).then(user => {
              this.$store.dispatch('updateSignedInUser', user)
              this.$refs['successModal'].show()
            })
          }
        ).catch(err => {
          this.confirmErrorMessage = err.message
          this.inError = true
        })
      },
      timedRedirect () {
        setTimeout(() => this.doRedirect(), 5000)
      },
      doRedirect () {
        this.$router.push({ name: 'dashboard' })
      }
    }
  }
</script>

<style>
  #confirmationForm {
    width: 50%
  }
</style>
